import { analytics } from '@redislabsdev/cloud-ui-analytics';
import { useLayoutEffect } from 'react';
import { useTheme } from 'styled-components/macro';

export const ThemeChangeHandler = () => {
  const theme = useTheme();
  useLayoutEffect(() => {
    document.body.classList.add('theme-transition');
    document.documentElement.setAttribute('theme', theme.name);
    window.sessionStorage.setItem('theme', theme.name);
    analytics.setGuidesAndSurveysTheme(theme.name === 'dark' ? 'darkMode' : 'lightMode');

    setTimeout(() => {
      document.body.classList.remove('theme-transition');
    }, 300);
  }, [theme.name]);

  return null;
};
